export const promoTypes = { percent: "Percentuale", fixed: "Sconto fisso", promoqta: "Quantità", paniere: "Paniere" };
export const euro = n => Number(n || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
export function availableArticles(catalog, suppliers) {
  return catalog.filter(s => suppliers.every(id => (s.supplier_ids || []).map(Number).includes(Number(id))));
}
export function configurationComplete(promo, catalog) {
  if (!["promoqta", "paniere"].includes(promo.kind)) return true;
  const scope = [...(promo.supplier_ids || []), ...(promo.supplier_id ? [promo.supplier_id] : [])];
  const allowed = new Set(availableArticles(catalog, scope).map(s => Number(s.id)));
  const rules = promo.kind === "promoqta" ? promo.qta_rules_detail || [] : promo.basket_rules_detail || [];
  return rules.length > 0 && rules.every(r => ["percent", "fixed", "pack_price"].includes(r.reward_type) &&
    (promo.kind === "promoqta" ? allowed.has(Number(r.service_id)) : r.items?.length > 0 && r.items.every(it => allowed.has(Number(it.service_id)))));
}
export function promoStatus(p, complete = true, now = Date.now()) {
  if (!complete || (p.requires_code && !p.code?.trim())) return "Configurazione incompleta";
  if (!p.active) return "Disattivata";
  if (p.starts_at && +new Date(p.starts_at) > now) return "Programmata";
  if (p.ends_at && +new Date(p.ends_at) < now) return "Scaduta";
  return "Attiva";
}
export function rewardText(r) {
  if (r.reward_type === "pack_price") return euro(r.reward_value);
  if (r.reward_type === "percent") return `sconto ${r.reward_value}%`;
  return `sconto ${euro(r.reward_value)}`;
}
export function ruleSummary(p) {
  if (p.kind === "percent") return `Sconto ${p.value}% sul subtotale articoli`;
  if (p.kind === "fixed") return `Sconto ${euro(p.value)} sul subtotale articoli`;
  if (p.kind === "promoqta") return (p.qta_rules_detail || []).map(r => `${r.trigger_qty} × ${r.service_desc || "Articolo non disponibile"} → ${rewardText(r)}${r.apply_per_multiple ? " · ripetibile" : " · una volta"}`).join("; ") || "Seleziona un articolo e configura la regola";
  return (p.basket_rules_detail || []).map(b => `${b.combined_qty} capi a scelta tra ${(b.items || []).map(it => it.service_desc).join(", ") || "articoli da selezionare"} → ${rewardText(b)}`).join("; ") || "Configura gli articoli del paniere";
}

export function compactRuleSummary(p) {
  if (p.kind === "percent") return `−${p.value}%`;
  if (p.kind === "fixed") return `−${euro(p.value)}`;
  const rules = p.kind === "promoqta" ? p.qta_rules_detail || [] : p.basket_rules_detail || [];
  if (!rules.length) return "Regola da completare";
  if (rules.length > 1) return `${rules.length} regole`;
  const rule = rules[0];
  if (p.kind === "promoqta") return `${rule.trigger_qty} × ${rule.service_desc || "Articolo da selezionare"} → ${rewardText(rule)}`;
  return `${rule.combined_qty} capi a scelta → ${rewardText(rule)}`;
}

export function validitySummary(p) {
  const date = value => new Date(value).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit" });
  if (!p.starts_at && !p.ends_at) return "Sempre";
  if (!p.starts_at) return `Fino al ${date(p.ends_at)}`;
  if (!p.ends_at) return `Dal ${date(p.starts_at)}`;
  return `${date(p.starts_at)}–${date(p.ends_at)}`;
}
